import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FormPage.css";

const FormPage = () => {
  const [appointments, setAppointments] = useState([]);
  const [message, setMessage] = useState("");

  // Fetch all appointments
  const fetchAppointments = async () => {
    try {
      const response = await axios.get(
        "https://api.swasthmitra.com/api/appointment/appointments"
      );
      setAppointments(response.data);
    } catch (error) {
      setMessage("Error fetching appointments");
    }
  };

  // Delete appointment by ID
  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://api.swasthmitra.com/api/appointment/appointments/${id}`
      );
      fetchAppointments(); // Reload the appointments after deletion
    } catch (error) {
      setMessage("Error deleting appointment");
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <div className="form-container">
      {message && <p className="error-message">{message}</p>}

      <h2>Appointments Request List</h2>
      <ul>
        {appointments.map((appointment) => (
          <li key={appointment._id} className="appointment-item">
            <div className="appointment-card">
              <div className="appointment-header">
                <strong>{appointment.name}</strong>
              </div>
              <div className="appointment-details">
                <div className="detail-item">
                  <strong>Name:</strong> <span>{appointment.name}</span>
                </div>
                <div className="detail-item">
                  <strong>Mobile Number:</strong>{" "}
                  <span>{appointment.mobileNumber}</span>
                </div>
                <div className="detail-item">
                  <strong>Address:</strong> <span>{appointment.address}</span>
                </div>
                <div className="detail-item">
                  <strong>Doctor Name:</strong>{" "}
                  <span>{appointment.doctorName}</span>
                </div>
                <div className="detail-item">
                  <strong>Hospital Name:</strong>{" "}
                  <span>{appointment.hospitalName}</span>
                </div>
                <div className="detail-item">
                  <strong>Hospital Address:</strong>{" "}
                  <span>{appointment.hospitalAddress}</span>
                </div>
                <div className="detail-item">
  <strong>Appointment Date:</strong>{" "}
  <span>
    {new Date(appointment.appointmentDate).toLocaleDateString("en-GB")}
  </span>
</div>

                {/* <div className="detail-item">
                  <strong>Appointment Date:</strong> <span>{new Date(appointment.createdAt).toLocaleString()}</span>
                </div> */}
              </div>
              <button
                onClick={() => handleDelete(appointment._id)}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FormPage;
